import React from 'react';

const About = () => {
  return (
    <div className="page-container" style={{background: 'var(--color-white)'}}>
      <div className="page-content" style={{padding: 'clamp(2rem, 4vw, 3rem) clamp(1rem, 3vw, 1.8rem)', maxWidth: '1200px', margin: '0 auto'}}>
        {/* Header Section - Centered */}
        <section className="modern-section" style={{padding: 'clamp(2rem, 5vw, 3rem) 0 clamp(2rem, 4vw, 3rem) 0', textAlign: 'center'}}>
          <div className="section-badge" style={{marginBottom: '1.5rem', fontSize: 'clamp(0.875rem, 2vw, 1rem)', background: 'var(--color-accent-light)', color: 'var(--color-primary)', padding: '0.5625rem 1.575rem', borderRadius: '30px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'inline-block'}}>À PROPOS DE NOUS !</div>
          <h1 className="section-title" style={{marginBottom: '1rem', fontSize: 'clamp(1.75rem, 5vw, 2.5rem)', color: 'var(--color-primary)', fontWeight: '600'}}>Bienvenue chez Callgarden</h1>
          <h2 className="section-title" style={{fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)', fontWeight: '400', color: 'var(--color-primary)', marginTop: '0', fontStyle: 'normal'}}>
            Une équipe de passionnés à votre écoute.
          </h2>
        </section>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(3rem, 5vw, 4rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '100%',
            margin: '0 auto'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/apropos/entrer.webp" 
                alt="Jardinier" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/apropos/plantesdelagagetopiaires.webp" 
                alt="Jardin moderne" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        {/* Company Description Section */}
        <section className="modern-section" style={{padding: 'clamp(2rem, 5vw, 3rem) 0', textAlign: 'center'}}>
          <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1.5rem', color: 'var(--color-primary)'}}>
            Callgarden : Passion des Espaces Verts
          </h2>
          <p className="page-text" style={{marginBottom: '2rem', fontSize: 'clamp(1rem, 2vw, 1.125rem)', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto 2rem', color: 'var(--color-gray)'}}>
            Callgarden est une entreprise d'amoureux des espaces verts, située dans le 91. Forts de notre expérience, nous intervenons sur toute l'Île-de-France pour l'entretien et l'aménagement de jardins. Passionnés par notre métier, nous proposons des services de qualité à des prix défiant toute concurrence.
          </p>

          {/* Service Cards */}
          <div className="cards-grid" style={{marginTop: '3rem', gap: '2rem', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))'}}>
            <div className="modern-card green-border" style={{
              borderColor: 'var(--color-accent-light)',
              borderWidth: '2px',
              padding: '2rem',
              textAlign: 'center'
            }}>
              <div className="card-icon" style={{
                width: '100px',
                height: '100px',
                background: 'var(--color-primary)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                padding: '20px'
              }}>
                <img src="/imgsection/apropos/Proffessionnel.svg" alt="Professionnel" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h3 className="card-title" style={{color: 'var(--color-primary)', fontSize: '1.5rem', marginBottom: '1rem'}}>Professionnel</h3>
              <p className="card-description" style={{color: 'var(--color-gray)', fontSize: '1rem'}}>
                Services de jardinage avec des outils performants.
              </p>
            </div>

            <div className="modern-card green-border" style={{
              borderColor: 'var(--color-accent-light)',
              borderWidth: '2px',
              padding: '2rem',
              textAlign: 'center'
            }}>
              <div className="card-icon" style={{
                width: '100px',
                height: '100px',
                background: 'var(--color-primary)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                padding: '20px'
              }}>
                <img src="/imgsection/apropos/Qualitee.svg" alt="Qualité" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h3 className="card-title" style={{color: 'var(--color-primary)', fontSize: '1.5rem', marginBottom: '1rem'}}>Qualité</h3>
              <p className="card-description" style={{color: 'var(--color-gray)', fontSize: '1rem'}}>
                Résultats garantis pour un jardin sain et esthétique.
              </p>
            </div>

            <div className="modern-card green-border" style={{
              borderColor: 'var(--color-accent-light)',
              borderWidth: '2px',
              padding: '2rem',
              textAlign: 'center'
            }}>
              <div className="card-icon" style={{
                width: '100px',
                height: '100px',
                background: 'var(--color-primary)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                padding: '20px'
              }}>
                <img src="/imgsection/apropos/PrixCompet.svg" alt="Prix compétitifs" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h3 className="card-title" style={{color: 'var(--color-primary)', fontSize: '1.5rem', marginBottom: '1rem'}}>Prix compétitifs</h3>
              <p className="card-description" style={{color: 'var(--color-gray)', fontSize: '1rem'}}>
                Des tarifs défiant toute concurrence.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
